import {createApp} from 'vue'
import CreateNewFileOverlay from './CreateNewFileOverlay'

const el = '.kb-component--create-new-file-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CreateNewFileOverlayDOM)=>{
            const component = createApp(CreateNewFileOverlay).use(Store)
            component.mount(CreateNewFileOverlayDOM)
        })
    }
}